import React from 'react';
import clsx from 'clsx';

import Icon from '@/elements/Icon/Icon.component';
import Text from '@/elements/Text/Text.component';
import { getLinkProps } from './ContactInfo.utils';

import { IProps } from '@/components/ContactInfo/ContactInfo.interface';
import '@/components/ContactInfo/ContactInfo.styles.css';

const ContactInfo: React.FC<IProps> = ({ icon, html, className }) => {
    const combinedClassName = clsx('contactInfo', className);
    const htmlIsString = typeof html === 'string';
    const linkProps = htmlIsString && icon && getLinkProps(icon, html);

    return (
        <span className={combinedClassName}>
            {icon ? <Icon icon={icon} className="contactInfo__icon" /> : null}
            {linkProps ? (
                <a
                    {...linkProps}
                    className="contactInfo__text contactInfo__text__link"
                >
                    {html as string}
                </a>
            ) : htmlIsString ? (
                <Text html={html} className="contactInfo__text card__text" as="span" />
            ) : (
                React.createElement('a', {
                    ...html,
                    className: 'contactInfo__text',
                })
            )}
        </span>
    );
};

export default ContactInfo;
